<div class="sidebar-container">
  <div class="section">
    @if (!isEntityLoading) {
      @if (_document?.company?.name || (entity !== null && entity.entityNumber) && _document?.type !== 'c:362a') {
        <div>
          <app-ag-tag-entity-title
            [isLink]="true"
            [entity]="_document?.company ?? entity!"
            [entityType]="entityType"
          />
        </div>
      }

      <div class="document-info-grid">
        <div class="info-item">
          <div class="info-item-title">Status</div>
          <app-ag-document-status [status]="_document?.documentStatus"/>
        </div>

        <div class="info-item" [hidden]="entityType == EntityType.Trust">
          <div class="info-item-title">Late fee</div>
          <div class="info-item-content" [class]="{'pink': lodgement?.lateFee}">
            {{ lodgement?.lateFee ? (lodgement?.lateFee | currency : "$" : 'code' : '1.2-2') : 'N/A' }}
          </div>
        </div>

        <div class="info-item">
          <div class="info-item-title">Signing Status</div>
          <app-ag-document-signing-status [status]="_document?.documentSigning?.signingStatus!"/>
        </div>

        <div class="info-item">
          <div class="info-item-title">Date Created</div>
          <div class="info-item-content">{{ _document?.createdOn | date: 'dd MMM yyyy' }}</div>
        </div>

        @if (currentStepIndex && currentStepIndex >= DocumentStepEnum.SignDocuments) {
          <div class="info-item">
            <div class="info-item-title">Date of Signature</div>
            <div
              class="info-item-content">{{ _document?.documentSigning?.signedOn ? (_document?.documentSigning?.signedOn | date: 'dd MMM yyyy' :'+1000') : 'N/A' }}
            </div>
          </div>
        }

        <div class="info-item" [hidden]="entityType == EntityType.Trust">
          <div class="info-item-title">Lodgement Deadline</div>
          <div class="info-item-content">
            {{ lodgement?.lodgementDeadline ? (lodgement?.lodgementDeadline | date : 'dd MMM yyyy') : 'N/A' }}
          </div>
        </div>

        <div class="info-item" [hidden]="entityType == EntityType.Trust || !_document?.lodgedOn">
          <div class="info-item-title">Lodgement Date</div>
          <div class="info-item-content">
            {{ _document?.lodgedOn ? (_document?.lodgedOn | date : 'dd MMM yyyy') : 'N/A' }}
          </div>
        </div>
      </div>

      <div class="tag-container">
        <div class="info-item-title">Tags</div>
        <div class="info-item-tag">
          @for (tag of entity?.tags; track $index) {
            <app-tag [tag]="tag"></app-tag>
          } @empty {
            N/A
          }
        </div>
      </div>
    } @else {
      <div class="skeleton-container">
        <ngx-skeleton-loader count="2" appearance="line"/>
        <div class="d-flex gap-12">
          <ngx-skeleton-loader style="width: 50%" count="3" appearance="line"/>
          <ngx-skeleton-loader style="width: 50%" count="3" appearance="line"/>
        </div>
      </div>
    }
  </div>

  <div class="section pt-3">
    @if (!loading) {
      @if (currentStepIndex && currentStepIndex >= DocumentStepEnum.SignDocuments) {
        <div class="documents-container">
          <div class="d-flex justify-content-between align-items-center">
            <div class="title-wrapper d-flex gap-12">
              <div>
                <i class="icon ic-documents-20"></i>
              </div>

              <div class="title font-size-16">Documents</div>
            </div>

            <div
              ngbDropdown
              class="dropdown"
              [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
            >
              <app-button
                ngbDropdownToggle
                btnColor="white"
                iconClass="icon ic-download-20"
              />

              <div ngbDropdownMenu class="common-dropdown-menu dropdown-menu dropdown-menu-right">
                <button ngbDropdownItem (click)="downloadCombinedPDF(DocumentSubFolderName.Final)">
                  <span>Download combined PDF</span>
                </button>

                <button ngbDropdownItem (click)="downloadZIP(DocumentSubFolderName.Final)">
                  <span>Download ZIP</span>
                </button>
              </div>
            </div>
          </div>

          <div class="generated-docs">
            <app-documents-list-accordion
              label="Generated"
              noDocsPlaceholder="No generated documents"
              [initialClosed]="false"
              [hideDeleteBtn]="true"
              [documents]="documentsList?.final ?? null"
              (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Final)"
            />
          </div>

          @if (documentsList?.original?.length) {
            <div class="original-docs">
              <app-documents-list-accordion
                label="Original"
                noDocsPlaceholder="No original documents"
                [initialClosed]="false"
                [hideDeleteBtn]="true"
                [documents]="documentsList?.original ?? null"
                (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Original)"
              />
            </div>
          }

          @if (documentsList?.signed?.length) {
            <div class="signed-docs">
              <app-documents-list-accordion
                label="Signed"
                noDocsPlaceholder="No signed documents"
                [hideDeleteBtn]="true"
                [documents]="documentsList?.signed ?? null"
                (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Signed)"
              />
            </div>
          }

          @if (currentStepIndex === DocumentStepEnum.SignDocuments || currentStepIndex === DocumentStepEnum.AsicResponse) {
            <div class="uploaded-docs">
              <app-documents-list-accordion
                label="Uploaded"
                noDocsPlaceholder="No uploaded files"
                [initialClosed]="!documentsList?.upload?.length"
                [documents]="documentsList?.upload ?? null"
                [hideDeleteBtn]="currentStepIndex === DocumentStepEnum.AsicResponse"
                (deleteFile)="deleteFile($event.name)"
                (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Upload)"
              />

              @if (currentStepIndex === DocumentStepEnum.SignDocuments) {
                <div class="uploaded-docs-controls">
                  <app-button
                    class="upload-file mt-2"
                    text="Upload File(s)"
                    (clickBtn)="openUploadFileModal(DocumentSubFolderName.Upload)"
                  />
                </div>
              }
            </div>
          }
        </div>
      }
    } @else {
      @if (currentStepIndex) {
        <div class="skeleton-container">
          <ngx-skeleton-loader count="6" appearance="line"/>
        </div>
      }
    }
  </div>

  <div class="section">
    @if (!loading) {
      @if (showRemindersSidebar) {
        <app-reminders-sidebar
          [isAnnualReminder]="false"
          [reminders]="_document?.reminders"
          [documentBase]="_document ?? null"
          [showPaymentReminder]="false"
          [lodgement]="lodgement"
        />
      }
    } @else {
      @if (currentStepIndex) {
        <div class="section">
          <div class="skeleton-container">
            <ngx-skeleton-loader count="6" appearance="line"/>
          </div>
        </div>
      }
    }
  </div>
</div>
